export const exploreWorlds = [
  {
    id: 'world-1',
    imgUrl: '/planet-01.png',
    title: 'Facebook',
    link: "https://www.facebook.com/toannv1712"
  },
  {
    id: 'world-2',
    imgUrl: '/planet-02.png',
    title: 'Github',
    link: "https://github.com/toannv72"
  },
  {
    id: 'world-3',
    imgUrl: '/planet-03.png',
    title: 'Tiktok',
    link: "https://www.tiktok.com/@toannv1712"
  },
  {
    id: 'world-4',
    imgUrl: '/planet-04.png',
    title: 'Mail',
    link: "mailto:toannv1712@gmail.com"
  },
  // {
  //   id: 'world-5',
  //   imgUrl: '/planet-05.png',
  //   title: 'Hawkins Labs',
  //   link: ""
  // },
];

export const startingFeatures = [
  'Tôi là Nguyễn Văn Toàn, sinh ngày 17/12/2000 tại Hồ Chí Minh.',
  'Tôi đam mê lập trình và luôn nỗ lực học hỏi, phát triển kỹ năng của mình.',
  'Hiện tại, tôi đang làm việc trên các dự án liên quan đến công nghệ và luôn sẵn sàng đón nhận những thách thức mới.',
];

export const newFeatures = [
  {
    imgUrl: '/vrpano.svg',
    title: 'Học tập tại Đại học FPT',
    subtitle: 'Hiện tại, tôi đang theo học ngành công nghệ thông tin tại Đại học FPT, nơi tôi đã phát triển nhiều kỹ năng về lập trình và phát triển phần mềm.',
  },
  {
    imgUrl: '/headset.svg',
    title: 'Chuyên về phát triển Web',
    subtitle: 'Tôi đã hoàn thiện nhiều dự án về phát triển web, sử dụng các công nghệ hiện đại như React, Node.js, và nhiều công cụ khác.',
  },
  {
    imgUrl: '/vrpano.svg',
    title: 'Quê ở Hà Nam',
    subtitle: 'Tôi sinh ra và lớn lên tại Hà Nam, một tỉnh yên bình ở miền Bắc Việt Nam.',
  },
];
export const insights = [
  {
    title: 'Sinh viên Đại học FPT',
    imgUrl: 'https://firebasestorage.googleapis.com/v0/b/careconnect-2d494.appspot.com/o/images%2F365c0243-5639-4eb9-931f-f75768426e4e.jpeg?alt=media&token=cf457d7a-576a-4700-b512-48b7296e6378',
    subtitle:
      'Nguyễn Văn Toàn hiện đang theo học tại Đại học FPT, chuyên ngành công nghệ thông tin, với mục tiêu trở thành một lập trình viên giỏi trong tương lai.',
  },
  {
    title: 'Đam mê phát triển Web',
    imgUrl: 'https://firebasestorage.googleapis.com/v0/b/careconnect-2d494.appspot.com/o/images%2F4eca6f42-5554-456a-aee0-90456f6abdc0.png?alt=media&token=54a8c819-acce-49fc-84dc-147ccfd771f5',
    subtitle:
      'Với kinh nghiệm trong phát triển Web, Toàn đã tham gia vào nhiều dự án sử dụng React, Node.js và các công nghệ tiên tiến khác.',
  },
  {
    title: 'Quê quán Hà Nam',
    imgUrl: 'https://firebasestorage.googleapis.com/v0/b/careconnect-2d494.appspot.com/o/images%2F00d89d92-6461-499a-9374-0a4078f8b27f.png?alt=media&token=acbbe31b-f25e-48c9-a280-c87e52015470',
    subtitle:
      'Sinh ra và lớn lên tại Hà Nam, một vùng đất yên bình, Toàn luôn tự hào về quê hương và những giá trị truyền thống mà nơi đây mang lại.',
  },
];


export const socials = [
  {
    name: 'twitter',
    url: '/twitter.svg',
    link:"https://www.facebook.com/toannv1712"
  },
  {
    name: 'linkedin',
    url: '/linkedin.svg',
    link: "https://www.facebook.com/toannv1712"
  },
  {
    name: 'instagram',
    url: '/instagram.svg',
    link: "https://www.facebook.com/toannv1712"
  },
  {
    name: 'facebook',
    url: '/facebook.svg',
    link: "https://www.facebook.com/toannv1712"
  },
];
